import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button } from '@pocketlaw/tetris';
import { useField } from 'formik';
import { Ranges } from './Ranges';
import { getFieldLabel } from '../../../utils/metadataProperties';
import { Breakdown } from '../Breakdown';
import { SelectDataPoint } from '../SelectDataPoint';
import { FieldInputContainer } from '../styled';
export function DateRangeInput(props) {
    var _a, _b;
    const { pathBase, remove, isSubAggregation = false } = props;
    const [open, setOpen] = useState(false);
    const currentPath = `${pathBase}.dateRangeInput`;
    const [field] = useField(currentPath);
    const rangeCount = (_b = (_a = field.value) === null || _a === void 0 ? void 0 : _a.ranges) === null || _b === void 0 ? void 0 : _b.length;
    return (<Fragment>
      <FieldInputContainer>
        <SelectDataPoint label={t({ message: 'Date range', comment: 'Insights widget form: Date range field' })} selectedValue={getFieldLabel(field.value.field)} name={pathBase} onRemove={remove}/>
        <Button type="button" onClick={() => setOpen(!open)} size="small" appearance="secondary">
          <Trans comment="Insights: Date range configuration">Ranges: {rangeCount}</Trans>
        </Button>
      </FieldInputContainer>

      {!isSubAggregation && <Breakdown pathBase={currentPath}/>}

      {open && <Ranges name={currentPath} onClose={() => setOpen(false)}/>}
    </Fragment>);
}
